import { Box, List, ListItem, ListItemIcon, ListItemText, styled } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { WsColors } from 'wisestep-base';

import { IOption } from '../../../../components/SettingsIndex';

const ActiveIndicator = styled(Box)({
  position: 'absolute',
  left: 0,
  top: 0,
  height: '100%',
  backgroundColor: WsColors.TheBlues500,
});

const NavItem = styled(ListItem)(({ isActive }: { isActive?: boolean }) => ({
  padding: '8px 16px',
  backgroundColor: isActive ? WsColors.TheBlues75 : 'transparent',
  '&:hover': {
    backgroundColor: isActive ? WsColors.TheBlues75 : WsColors.LightGray,
  },
}));

const NavItemText = styled(ListItemText)({
  '& .MuiListItemText-primary': {
    fontSize: 14,
    fontWeight: 500,
  },
});

const NavItemIcon = styled(ListItemIcon)({
  minWidth: 40,
  color: WsColors.GenericRichBlack,
});

export interface SideNavBarContainerProps {
  sideMenuOptions: IOption[];
}

export const SideNavBarContainer = ({ sideMenuOptions }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedItem = sideMenuOptions.findIndex(
    (menuOption) => menuOption.url == location.pathname
  );

  const navigateToUrl = (item: IOption) => navigate(item.url ?? '/home');
  return (
    <List sx={{ py: 2, cursor: 'pointer' }}>
      {sideMenuOptions.map((item, index) => (
        <NavItem key={index} onClick={() => navigateToUrl(item)} isActive={selectedItem === index}>
          {selectedItem === index && <ActiveIndicator width={4} />}
          <NavItemIcon>{item.icon}</NavItemIcon>
          <NavItemText primary={item.label} />
        </NavItem>
      ))}
    </List>
  );
};
